export enum Events {
  FormStart = 'form_start',
  FormSuccessSubmit = 'successful_form_submit',
  FormFailSubmit = 'failed_form_submit'
}
